import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "trigger"]
  static values = { 
    status: String,
    umsatzvolumen: String,
    entscheidungstraeger: String,
    bedarfstraeger: String,
    anfragen: String
  }

  connect() {
    this.hide()
    document.addEventListener('click', this.clickOutside.bind(this))
  }

  show() {
    this.contentTarget.classList.remove('hidden')
    this.contentTarget.classList.add('block')
  }

  hide() {
    this.contentTarget.classList.add('hidden')
    this.contentTarget.classList.remove('block')
  }

  toggle() {
    if (this.contentTarget.classList.contains('hidden')) {
      this.show()
    } else {
      this.hide()
    }
  }

  // Schließen wenn außerhalb geklickt wird
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.clickOutside.bind(this))
  }
} 